module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-center-215df9413dfd4259697cb49bdd34ae32.svg";